<template>
    <div>

        <section id="main-area">
            <div class="container" style="min-height:100px;padding-top: 45px">
                <div class="row">
                    <div class="col-12 col-lg-9 pr-lg-0">
                        <div class="card p-4 mt-2" v-if="!ticket_success">
                            <div class="d-block d-flex justify-content-center">
                                <h5>Lütfen Bekleyiniz.</h5>
                            </div>
                            <div class="d-flex justify-content-center">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                        <mdb-jumbotron v-if="reservationNoApproved ">
                            <mdb-row>
                                <mdb-col md="4" offsetMd="1" class="m-3">
                                    <img src="../assets/images/Logo.png">
                                </mdb-col>
                                <mdb-col md="7" class="text-md-left ml-3 mt-3">
                                    <p>Ödeme işleminde bir sorun oluştu. Lütfen bizimle iletişime geçiniz. </p>
                                    <h4>{{messages}}</h4>
                                </mdb-col>
                            </mdb-row>
                        </mdb-jumbotron>
                        <mdb-jumbotron class="mb-0 text-center hoverable p-4" v-if="ticket_success">
                            <mdb-row>
                                <mdb-col md="4" offsetMd="1" class="m-3">
                                    <img src="../assets/images/Logo.png">
                                </mdb-col>
                                <mdb-col md="7" class="text-md-left ml-3 mt-3">
                                    <a href="#!" class="green-text">
                                        <h6 class="h6 pb-1">
                                            <mdb-icon icon="plane" class="pr-1"/>
                                            İşleminiz Başarılı Bir Şekilde Gerçekleşti
                                        </h6>
                                    </a>
                                    <h4 class="h4 mb-4">Biletbul Ailesi olarak iyi uçuşlar dileriz.</h4>
                                    <p class="font-weight-normal">Uçuş için rezervasyon kayıt numarası ve fotoğraflı
                                        kimliğinizi
                                        (yurtdışı uçuşlarında pasaport) yanınızda bulundurmanız yeterli olacaktır.
                                        Lütfen uçuşunuzun kalkış saatinden en geç 2 saat önce havaalanında olunuz.</p>
                                    <p class="font-weight-normal"><strong>Rezervasyon (PNR) No: </strong> {{pnr}}</p>
                                    <mdb-btn color="success" v-print="'#print-area'">
                                        <mdb-icon icon="print"/>
                                        Bileti Yazdır
                                    </mdb-btn>
                                </mdb-col>
                            </mdb-row>
                        </mdb-jumbotron>
                        <div class="row d-none">
                            <div id="print-area">
                                <div v-if="reservationAllTrue && reservationAll.length !== 0">
                                    <div v-if="!Array.isArray(reservationAll.Passengers.T_Passenger)" class="mt-3">
                                        <div class="row">
                                            <div class="col"></div>
                                            <div class="col-10">
                                                <div class="row">
                                                    <div class="col-12" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Sayın,</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{reservationAll.Passengers.T_Passenger.FirstName}}
                                                            {{reservationAll.Passengers.T_Passenger.LastName}}</strong>
                                                        </p>
                                                    </div>
                                                    <div class="col-12" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">
                                                        <p style="font-size: 18px;margin-bottom: 0">Biletinizi başarılı
                                                            bir şekilde satın aldınız. </p>
                                                        <p style="font-size: 18px;margin-bottom: 0">Uçuş detaylarınız ve
                                                            elektronik biletiniz aşağıdadır </p>
                                                    </div>
                                                </div>
                                                <div class="row" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">
                                                    <div class="col-6" style="padding: 15px;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Rezervasyon No:</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{Array.isArray(reservationAll.AirBookings.T_AirBooking)?reservationAll.AirBookings.T_AirBooking[0].BookingCode:reservationAll.AirBookings.T_AirBooking.BookingCode}}</strong>
                                                        </p>
                                                    </div>
                                                    <div class="col-6" style="padding: 15px;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Bilet No:</p>
                                                        <p style="font-size: 22px;margin-bottom: 0">
                                                            <strong
                                                                v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)" >
                                                                <div v-for="AirBooking in reservationAll.AirBookings.T_AirBooking">
                                                                    {{Array.isArray(AirBooking.BookingItems.T_AirBookingItem)?rAirBooking.BookingItems.T_AirBookingItem[index].TicketNumber:AirBooking.BookingItems.T_AirBookingItem.TicketNumber}}
                                                                </div>
                                                            </strong>
                                                            <strong v-else>
                                                            {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].TicketNumber:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.TicketNumber}}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <div class="row" style="margin-top: 7px">
                                            <div class="col"></div>
                                            <div class="col-md-10 p-0">
                                                <table class="table w-100" style="border-radius: 12px;
                                                        background-color: #0a9fda;
                                                        box-shadow: none;
                                                        padding: 0.5rem 1rem;color:black">
                                                    <th>GİDİŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr v-for="segment in reservationAll.Segments"
                                                        v-if="segment.od_destination_code == reservationAll.Segments[0].od_destination_code">
                                                        <td>
                                                            <p><b>{{segment.marketing_airline_name}}</b></p>
                                                            <p>Class</p>
                                                            <p><b>{{segment.flight_number}}</b></p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.departure_time}}</b></p>
                                                            <p>{{segment.departure_day}}</p>
                                                            <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.arrival_time}}</b></p>
                                                            <p>{{segment.arrival_day}}</p>
                                                            <p><b>{{segment.destination_name}}
                                                                ({{segment.destination_code}})</b></p>
                                                        </td>
                                                        <td>
                                                            <p>{{segment.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                            <span v-for="airbla in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla.BookingItems.T_AirBookingItem)?airbla.BookingItems.T_AirBookingItem[index].Baggage:airbla.BookingItems.T_AirBookingItem.Baggage}}
                                                            </span>
                                                            </p>
                                                            <p v-else>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table class="table w-100" style="border-radius: 12px;
                                                            background-color: #0a9fda;
                                                            box-shadow: none;
                                                            padding: 0.5rem 1rem;color:black"
                                                       v-if="reservationAll.Segments.length > 1 && reservationAll.Segments[0].od_destination_code !== reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                    <th>DÖNÜŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr v-for="segment in reservationAll.Segments"
                                                        v-if="segment.od_destination_code == reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                        <td>
                                                            <p><b>{{segment.marketing_airline_name}}</b></p>
                                                            <p>Class</p>
                                                            <p><b>{{segment.flight_number}}</b></p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.departure_time}}</b></p>
                                                            <p>{{segment.departure_day}}</p>
                                                            <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.arrival_time}}</b></p>
                                                            <p>{{segment.arrival_day}}</p>
                                                            <p><b>{{segment.destination_name}}
                                                                ({{segment.destination_code}})</b></p>
                                                        </td>
                                                        <td>
                                                            <p>{{segment.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                            <span v-for="airbla in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla.BookingItems.T_AirBookingItem)?airbla.BookingItems.T_AirBookingItem[index].Baggage:airbla.BookingItems.T_AirBookingItem.Baggage}}
                                                            </span>
                                                            </p>
                                                            <p v-else>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>


                                                <div class="col-12">
                                                    <div class="row" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                        <div class="col-12"><p style=" margin-bottom: 0">TOPLAM TUTAR</p>
                                                        </div>
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Esas Ücret</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                    {{topla(reservationAll.AirBookings.T_AirBooking,index,"BaseFare")}}
                                                            <!--span v-for="airbla2 in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla2.BookingItems.T_AirBookingItem)?airbla2.BookingItems.T_AirBookingItem[index].BaseFare.slice(0,
                                                            -2):airbla2.BookingItems.T_AirBookingItem.BaseFare.slice(0,
                                                            -2)}}
                                                            </span-->
                                                                </strong>
                                                                <strong v-else>
                                                                    {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].BaseFare.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.BaseFare.slice(0,
                                                                    -2)}}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Vergi</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                    {{topla(reservationAll.AirBookings.T_AirBooking,index,"Taxes")}}
                                                                </strong>
                                                                <strong v-else>
                                                                    {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Taxes.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Taxes.slice(0,
                                                                    -2)}}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Toplam Fiyat</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                    {{topla(reservationAll.AirBookings.T_AirBooking,index,"NetFare")}}
                                                                </strong>
                                                                <strong v-else>
                                                                    {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].NetFare.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.NetFare.slice(0,
                                                                    -2)}}
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="margin-top: 15px">
                                                    <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">Genel Kurallar
                                                    </div>
                                                    <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                        <p>&nbsp;</p>
                                                        <p>* YOLCULARIMIZIN HAVALİMANINA İÇ HAT UÇUŞLARINDA EN GEÇ 3
                                                            SAAT,
                                                            DIŞ HAT
                                                            UÇUŞLARINDA EN GEÇ 4 SAAT ÖNCE GELMELERİ GEREKMEKTEDİR.</p>

                                                        <p>* KALKIŞ VE VARIŞ SAATLERİ YEREL SAATE GÖRE
                                                            BELİRTİLMİŞTİR.</p>

                                                        <p>* YOLCUNUN GİDECEGİ ÜLKE&#39;YE AİT GEÇERLİ BİR VİZESİ,
                                                            AKTARMALI
                                                            UÇUŞLARDA TRANSİT VİZESİ
                                                            OLMAMASI SEBEBİYLE SEYAHATİN GERCEKLEŞMEMESİ HALİNDE
                                                            ‘BİLETBUL
                                                            TURİZM’ SORUMLU
                                                            DEĞİLDİR.</p>

                                                        <p>* COVID 19 ÖNLEMLERİ KAPSAMINDA ÜLKELERE GİRİŞ VE ÇIKIŞLARDA
                                                            FARKLI KURALLAR
                                                            UYGULANMAKTADIR VE DEĞİŞKENLİK GÖSTERMEKTEDİR, GİDİLECEK
                                                            OLAN
                                                            ÜLKENİN KURALLARINI
                                                            KONSOLOSLUKTAN TEYİT ETMEK YOLCUNUN SORUMLULUĞUNDADIR.</p>

                                                        <p>* COVID 19 ÖNLEMLERİ ÇERÇEVESİNDE MİSAFİRLERİN GÜVENLİĞİ İÇİN
                                                            UÇAK İÇERİSİNE KABİN BAGAJI
                                                            ALINMAYACAKTIR.UÇAK İÇERİSİNE SADECE 1 ADET KADIN EL
                                                            ÇANTASI,
                                                            LAPTOP, EVRAK ÇANTASI VEYA
                                                            BEBEK MALZEME ÇANTASI ALINABİLECEKTİR.</p>

                                                        <p>* İÇ HAT UÇUŞLARINDA TÜRKİYE CUMHURİYETİ VATANDAŞLARI VE
                                                            TÜRKİYE
                                                            CUMHURİYETİ YABANCI
                                                            KİMLİĞİNE SAHİP YOLCULARIMIZIN HES KODUNA SAHİP OLMALARI
                                                            ZORUNLUDUR.</p>

                                                        <p>* HAVAYOLLARININ KURALLARINA GÖRE ÖZELLİKLE UZUN MENZİLLİ
                                                            UÇUSLARDA CHECKIN
                                                            İŞLEMLERİ ERKEN BİTEBİLMEKTE OLUP, PARÇA BAGAJ HAKLARI
                                                            HAVAYOLUNA GÖRE
                                                            DEGİŞİKLİK ARZ EDEBİLMEKTEDİR.</p>
                                                        <br/><br/><br/>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <hr>
                                    </div>
                                    <div v-else v-for="(passenger,index) in reservationAll.Passengers.T_Passenger"
                                         :key="index" class="mt-3">
                                        <div class="row">
                                            <div class="col"></div>
                                            <div class="col-10">
                                                <div class="row">
                                                    <div class="col-12"
                                                         style="background-color: #ececec; padding: 15px; border-radius: 6px; margin-bottom: 15px">
                                                        <p style="font-size: 16px;margin-bottom: 0">Sayın,</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{passenger.FirstName}}
                                                            {{passenger.LastName}}</strong></p>
                                                    </div>
                                                    <div class="col-12"
                                                         style="background-color: #61af61; padding: 15px; border-radius: 6px; color:white">
                                                        <p style="font-size: 18px;margin-bottom: 0">Biletinizi başarılı
                                                            bir şekilde satın aldınız. </p>
                                                        <p style="font-size: 18px;margin-bottom: 0">Uçuş detaylarınız ve
                                                            elektronik biletiniz aşağıdadır </p>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top: 25px;">
                                                    <div class="col-6"
                                                         style="background-color: #ececec; padding: 15px;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Rezervasyon No:</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{reservationAll.AirBookings.T_AirBooking.BookingCode}}</strong>
                                                        </p>
                                                    </div>
                                                    <div class="col-6"
                                                         style="background-color: lightgray; padding: 15px;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Bilet No:</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].TicketNumber:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.TicketNumber}}</strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <div class="row" style="margin-top: 7px">
                                            <div class="col"></div>
                                            <div class="col-10 p-0">
                                                <table class="table w-100">
                                                    <th>GİDİŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr v-for="segment in reservationAll.Segments"
                                                        v-if="segment.od_destination_code == reservationAll.Segments[0].od_destination_code">
                                                        <td>
                                                            <p><b>{{segment.marketing_airline_name}}</b></p>
                                                            <p>Class</p>
                                                            <p><b>{{segment.flight_number}}</b></p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.departure_time}}</b></p>
                                                            <p>{{segment.departure_day | moment("Do MMMM YYYY, dddd
                                                                ")}}</p>
                                                            <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.arrival_time}}</b></p>
                                                            <p>{{segment.arrival_day | moment("Do MMMM YYYY, dddd
                                                                ")}}</p>
                                                            <p><b>{{segment.destination_name}}
                                                                ({{segment.destination_code}})</b></p>
                                                        </td>
                                                        <td>
                                                            <p>{{segment.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}</p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table class="table w-100"
                                                       v-if="reservationAll.Segments.length > 1 && reservationAll.Segments[0].od_destination_code !== reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                    <th>DÖNÜŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr v-for="segment in reservationAll.Segments"
                                                        v-if="segment.od_destination_code == reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                        <td>
                                                            <p><b>{{segment.marketing_airline_name}}</b></p>
                                                            <p>Class</p>
                                                            <p><b>{{segment.flight_number}}</b></p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.departure_time}}</b></p>
                                                            <p>{{segment.departure_day | moment("Do MMMM YYYY, dddd
                                                                ")}}</p>
                                                            <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{segment.arrival_time}}</b></p>
                                                            <p>{{segment.arrival_day | moment("Do MMMM YYYY, dddd
                                                                ")}}</p>
                                                            <p><b>{{segment.destination_name}}
                                                                ({{segment.destination_code}})</b></p>
                                                        </td>
                                                        <td>
                                                            <p>{{segment.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}</p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <div class="col-12">
                                                    <p style=" margin-bottom: 0">TOPLAM TUTAR</p>
                                                </div>
                                                <div class="col-12">
                                                    <div class="row">
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Esas Ücret</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong>{{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].BaseFare.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.BaseFare.slice(0,
                                                                    -2)}}</strong></p>
                                                        </div>
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Vergi</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong>{{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Taxes.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Taxes.slice(0,
                                                                    -2)}}</strong></p>
                                                        </div>
                                                        <div class="col-4">
                                                            <p style="margin-bottom: 0;font-size: 16px">Toplam Fiyat</p>
                                                            <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                                <strong>{{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].NetFare.slice(0,
                                                                    -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.NetFare.slice(0,
                                                                    -2)}}</strong></p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="margin-top: 15px">
                                                    <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">Genel Kurallar
                                                    </div>
                                                    <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                        <p>&nbsp;</p>
                                                        <p>* YOLCULARIMIZIN HAVALİMANINA İÇ HAT UÇUŞLARINDA EN GEÇ 3
                                                            SAAT, DIŞ HAT
                                                            UÇUŞLARINDA EN GEÇ 4 SAAT ÖNCE GELMELERİ GEREKMEKTEDİR.</p>

                                                        <p>* KALKIŞ VE VARIŞ SAATLERİ YEREL SAATE GÖRE
                                                            BELİRTİLMİŞTİR.</p>

                                                        <p>* YOLCUNUN GİDECEGİ ÜLKE&#39;YE AİT GEÇERLİ BİR VİZESİ,
                                                            AKTARMALI UÇUŞLARDA TRANSİT VİZESİ
                                                            OLMAMASI SEBEBİYLE SEYAHATİN GERCEKLEŞMEMESİ HALİNDE
                                                            ‘BİLETBUL TURİZM’ SORUMLU
                                                            DEĞİLDİR.</p>

                                                        <p>* COVID 19 ÖNLEMLERİ KAPSAMINDA ÜLKELERE GİRİŞ VE ÇIKIŞLARDA
                                                            FARKLI KURALLAR
                                                            UYGULANMAKTADIR VE DEĞİŞKENLİK GÖSTERMEKTEDİR, GİDİLECEK
                                                            OLAN ÜLKENİN KURALLARINI
                                                            KONSOLOSLUKTAN TEYİT ETMEK YOLCUNUN SORUMLULUĞUNDADIR.</p>

                                                        <p>* COVID 19 ÖNLEMLERİ ÇERÇEVESİNDE MİSAFİRLERİN GÜVENLİĞİ İÇİN
                                                            UÇAK İÇERİSİNE KABİN BAGAJI
                                                            ALINMAYACAKTIR.UÇAK İÇERİSİNE SADECE 1 ADET KADIN EL
                                                            ÇANTASI, LAPTOP, EVRAK ÇANTASI VEYA
                                                            BEBEK MALZEME ÇANTASI ALINABİLECEKTİR.</p>

                                                        <p>* İÇ HAT UÇUŞLARINDA TÜRKİYE CUMHURİYETİ VATANDAŞLARI VE
                                                            TÜRKİYE CUMHURİYETİ YABANCI
                                                            KİMLİĞİNE SAHİP YOLCULARIMIZIN HES KODUNA SAHİP OLMALARI
                                                            ZORUNLUDUR.</p>

                                                        <p>* HAVAYOLLARININ KURALLARINA GÖRE ÖZELLİKLE UZUN MENZİLLİ
                                                            UÇUSLARDA CHECKIN
                                                            İŞLEMLERİ ERKEN BİTEBİLMEKTE OLUP, PARÇA BAGAJ HAKLARI
                                                            HAVAYOLUNA GÖRE
                                                            DEGİŞİKLİK ARZ EDEBİLMEKTEDİR.</p>
                                                        <br/><br/><br/>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                                <div v-if="reservationAllCharter">
                                    <div v-for="(passenger,index) in reservationAllCharter.person" :key="index"
                                         class="mt-3">
                                        <div class="row">
                                            <div class="col"></div>
                                            <div class="col-10">
                                                <div class="row">
                                                    <div class="col-12"
                                                         style="background-color: #ececec; padding: 15px; border-radius: 6px; margin-bottom: 15px">
                                                        <p style="font-size: 16px;margin-bottom: 0">Sayın,</p>
                                                        <p style="font-size: 22px;margin-bottom: 0"><strong>{{passenger.first_name}}
                                                            {{passenger.last_name}}</strong></p>
                                                    </div>
                                                    <div class="col-12"
                                                         style="background-color: #61af61; padding: 15px; border-radius: 6px; color:white">
                                                        <p style="font-size: 18px;margin-bottom: 0">Biletinizi başarılı
                                                            bir şekilde satın aldınız. </p>
                                                        <p style="font-size: 18px;margin-bottom: 0">Uçuş detaylarınız ve
                                                            elektronik biletiniz aşağıdadır </p>
                                                        <p style="font-size: 18px;margin-bottom: 0">Biletinizin
                                                            detaylarını 24 saat öncesinden teyit etmelisiniz.</p>
                                                    </div>
                                                </div>
                                                <div class="row" style="margin-top: 25px;">
                                                    <div class="col-12"
                                                         style="background-color: #ececec; padding: 15px;">
                                                        <p style="font-size: 16px;margin-bottom: 0">Rezervasyon No:</p>
                                                        <p style="font-size: 22px;margin-bottom: 0">
                                                            <strong>{{pnr}}</strong></p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <div class="row" style="margin-top: 7px">
                                            <div class="col"></div>
                                            <div class="col-10 p-0">
                                                <table class="table w-100">
                                                    <th>GİDİŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr>
                                                        <td>
                                                            <p><b>{{reservationAllCharter.departure_charter.airline_name}}</b>
                                                            </p>
                                                            <p>Class</p>
                                                            <p><b>{{reservationAllCharter.departure_charter.class}}</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{reservationAllCharter.departure_charter.departure_hour}}</b>
                                                            </p>
                                                            <p>
                                                                {{reservationAllCharter.departure_charter.departure_date}}</p>
                                                            <p><b>{{reservationAllCharter.departure_charter.from_city_code}}
                                                                ({{reservationAllCharter.departure_charter.from_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{reservationAllCharter.departure_charter.arrival_hour}}</b>
                                                            </p>
                                                            <p>
                                                                {{reservationAllCharter.departure_charter.arrival_date}}</p>
                                                            <p><b>{{reservationAllCharter.departure_charter.to_city_code}}
                                                                ({{reservationAllCharter.departure_charter.to_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p>{{reservationAllCharter.departure_charter.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p>{{reservationAllCharter.departure_charter.baggage}}</p>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <table class="table w-100"
                                                       v-if="reservationAllCharter.arrival_charter.id">
                                                    <th>DÖNÜŞ UÇUŞU</th>
                                                    <th>KALKIŞ</th>
                                                    <th>VARIŞ</th>
                                                    <th>SÜRE</th>
                                                    <th>BAGAJ</th>
                                                    <tr>
                                                        <td>
                                                            <p>
                                                                <b>{{reservationAllCharter.arrival_charter.airline_name}}</b>
                                                            </p>
                                                            <p>Class</p>
                                                            <p><b>{{reservationAllCharter.arrival_charter.class}}</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p><b>{{reservationAllCharter.arrival_charter.departure_hour}}</b>
                                                            </p>
                                                            <p>
                                                                {{reservationAllCharter.arrival_charter.departure_date}}</p>
                                                            <p><b>{{reservationAllCharter.arrival_charter.from_city_code}}
                                                                ({{reservationAllCharter.arrival_charter.from_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                <b>{{reservationAllCharter.arrival_charter.arrival_hour}}</b>
                                                            </p>
                                                            <p>
                                                                {{reservationAllCharter.arrival_charter.arrival_date}}</p>
                                                            <p><b>{{reservationAllCharter.arrival_charter.to_city_code}}
                                                                ({{reservationAllCharter.arrival_charter.to_code}})</b>
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <p>{{reservationAllCharter.arrival_charter.duration}}</p>
                                                        </td>
                                                        <td>
                                                            <p>{{reservationAllCharter.arrival_charter.baggage}}</p>
                                                        </td>

                                                    </tr>
                                                </table>
                                                <div class="col-12" style="background-color:#ececec; padding: 15px ">
                                                    <p style="font-size: 24px; margin-bottom: 0">TOPLAM TUTAR</p>
                                                    <p style="margin-bottom: 0;font-size: 28px"><strong>{{reservationAllCharter.amount_paid}}TL</strong>
                                                    </p>
                                                </div>
                                                <div style="margin-top: 15px">
                                                    <div style="font-size: 24px;background-color:#ececec;padding: 15px ">
                                                        Genel Kurallar
                                                    </div>
                                                    <p>YOLCULARIMIZIN HAVALİMANINA İÇ HAT UÇUŞLARINDA EN GEÇ 3 SAAT, DIŞ
                                                        HAT UÇUŞLARINDA EN GEÇ
                                                        4 SAAT ÖNCE GELMELERİ GEREKMEKTEDİR.
                                                        * YOLCUNUZUN GIDECEGI ULKE'YE AIT GECERLI BIR VIZESI AKTARMALI
                                                        UCUSLARDA TRANSIT VIZESI OLMAMASI SEBEBIYLE
                                                        SEYAHATIN GERCEKLESMEMESI HALINDE BILETBANK (AKDENİZ PE-TUR A.S)
                                                        SORUMLU DEGILDIR.</p>
                                                </div>
                                                <div>
                                                    <div style="font-size: 24px;background-color:#ececec;padding: 15px ">
                                                        Önemli Bilgilendirme
                                                    </div>
                                                    <p>HAVAYOLLARININ KURALLARINA GORE OZELLIKLE UZUN MENZILLI UCUSLARDA
                                                        CHECK-IN ISLEMLERI ERKEN BITEBILMEKTE OLUP,

                                                        PARCA BAGAJ HAKLARI HAVAYOLUNA GORE DEGISIKLIK ARZ
                                                        EDEBILMEKTEDIR.</p>
                                                </div>
                                            </div>
                                            <div class="col"></div>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-none d-lg-block col-lg-3 pr-lg-0 ">

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mdbJumbotron, mdbRow, mdbCol, mdbView, mdbBtn, mdbIcon, mdbMask} from 'mdbvue';
    import findFlight from '@/components/findFlight';
    import axios from "axios";

    export default {
        components: {
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbIcon,
            mdbRow,
            mdbCol,
            mdbBtn,
            'bb-findflight': findFlight,
        },
        data() {
            return {
                modal: false,
                toggle: false,
                ticket_success: false,
                reservationAll: [],
                reservationAllTrue: false,
                reservationAllCharter: [],
                reservationNoApproved: false,
                messages: "",
                persons:
                    {
                        NetFare: "146",
                        pnr: "",
                        person: [
                            {
                                type: "",
                                birth_datef: "",
                                citizen_no: "",
                                first_name: "Murat",
                                gender: "E",
                                last_name: "Bayhan",
                                sequence_no: "",
                                pax_reference_id: "",
                                nationality: "",
                                passport_country: "TR",
                                passport_no: "U123456",
                                passport_valid_date: "2025-05-05",
                                miles_id: ""
                            }
                        ],
                        departure_charter: [{
                            "id": 1,
                            "airline_code": "TK",
                            "airline_name": "Turkish Airlines",
                            "from_code": "AYT",
                            "from_name": "Antalya",
                            "from_country_code": "TR",
                            "from_country_name": "T\u00fcrkiye",
                            "from_city_name": "AYT",
                            "from_city_code": "Antalya",
                            "to_code": "IST",
                            "to_name": "Istanbul",
                            "to_country_code": "TR",
                            "to_country_name": "T\u00fcrkiye",
                            "to_city_name": "IST",
                            "to_city_code": "\u0130stanbul",
                            "departure_date": "2020-06-01",
                            "arrival_date": "2020-05-02",
                            "departure_hour": "22:00",
                            "arrival_hour": "01:00",
                            "adult": "1.00",
                            "baby": "1.00",
                            "duration": "2",
                            "seat_count": 5,
                            "class": "First Class",
                            "flight_number": "TK1233",
                            "baggage": "20"
                        }],
                        arrival_charter: [],
                    }

            };
        },
        methods: {
            topla(ar,index,name){

                let toplam = 0
                ar.filter(function (a) {
                    toplam += parseFloat(a.BookingItems.T_AirBookingItem[name])
                })

                return toplam.toFixed(2)
            },
            finalizeShoping() {
                var self = this;
                var billing_name, tax_office, tax_office, tax_number, address_detail, zip_code, address_district, city;
                self.reservationNoApproved = false;
                if (localStorage.billing_name) {
                    billing_name = localStorage.billing_name;
                    tax_office = localStorage.tax_office;
                    tax_number = localStorage.tax_number;
                    address_detail = localStorage.address_detail;
                    zip_code = localStorage.zip_code;
                    address_district = localStorage.address_district;
                    city = localStorage.city;
                    localStorage.removeItem("billing_name");
                    localStorage.removeItem("tax_office");
                    localStorage.removeItem("tax_number");
                    localStorage.removeItem("address_detail");
                    localStorage.removeItem("zip_code");
                    localStorage.removeItem("address_district");
                    localStorage.removeItem("city");
                }
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/finalize_shopping", {
                    session_token: localStorage.sessionToken,
                    session_id: localStorage.sessionId,
                    api_token: localStorage.api_token,
                    shopping_file_id: localStorage.makeBooking,
                    billing_name: billing_name,
                    tax_office: tax_office,
                    tax_number: tax_number,
                    address_detail: address_detail,
                    zip_code: zip_code,
                    address_district: address_district,
                    city: city
                })
                    .then(function (response) {
                        if (response.data.data.FinalizeShoppingResult.HasError === false) {
                            self.ticket_success = true;
                            self.pnr = response.data.data.FinalizeShoppingResult.ShoppingFile.AirBookings.T_AirBooking.BookingCode;
                            self.reservationAll = response.data.data.FinalizeShoppingResult.ShoppingFile;
                            setTimeout(function () {
                                self.reservationAllTrue = true;
                            }, 500);
                            //window.location.href = '/#/success';
                            //router({ name: 'success', params: { userId: 123 }});
                        }
                    });
            },
            finalizeCharter() {
                var self = this;
                let datas = "";
                if (localStorage.departure_charter) {
                    datas = {
                        product_type: "charter",
                        departure_charter: JSON.parse(localStorage.departure_charter),
                        arrival_charter: JSON.parse(localStorage.arrival_charter),
                        api_token: localStorage.api_token,
                        billing_name: localStorage.billing_name,
                        tax_office: localStorage.tax_office,
                        tax_number: localStorage.tax_number,
                        address_detail: localStorage.address_detail,
                        zip_code: localStorage.zip_code,
                        address_district: localStorage.address_district,
                        city: localStorage.city,
                        person: JSON.parse(localStorage.persons),
                        amount_paid: localStorage.amount_paid,
                        contact_email: localStorage.contact_email,
                        contact_phone: localStorage.contact_phone,

                    }
                    localStorage.removeItem("billing_name");
                    localStorage.removeItem("tax_office");
                    localStorage.removeItem("tax_number");
                    localStorage.removeItem("address_detail");
                    localStorage.removeItem("zip_code");
                    localStorage.removeItem("address_district");
                    localStorage.removeItem("city");
                    localStorage.removeItem("departure_charter");
                    localStorage.removeItem("departure_charter_id");
                    localStorage.removeItem("arrival_charter");
                    localStorage.removeItem("return_charter_id");
                    localStorage.removeItem("persons");
                    localStorage.removeItem("contact_email");
                    localStorage.removeItem("contact_phone");
                    localStorage.removeItem("amount_paid");
                }
                axios.post("https://www.biletbul.com/backend/public/api/v1/flight/finalize_shopping", datas)
                    .then(function (response) {
                        if (response.data.status === true) {
                            self.reservationNoApproved = false;
                            self.ticket_success = true;
                            self.pnr = response.data.data.booking_code;
                            self.reservationAllCharter = response.data.data;
                            console.log(self.reservationAllCharter);
                            //window.location.href = '/#/success';
                            //router({ name: 'success', params: { userId: 123 }});
                        }
                    });
            },
        },
        mounted() {
            if (localStorage.departure_charter_id) {
                if (this.$route.query.status === "true") {
                    this.reservationNoApproved = false;
                    this.finalizeCharter();
                } else {
                    this.messages = this.$route.query.message;
                    this.reservationNoApproved = true;
                }
            } else {
                if (this.$route.query.Approved === 'true' || this.$route.query.Approved === true) {
                    this.reservationNoApproved = false;
                    this.finalizeShoping();
                } else {
                    this.reservationNoApproved = true;
                }
            }
        }
    };
</script>

<style scoped>
    th {
        background-color: #0a9fda;
        font-size: 19px;
    }

    tr p {
        margin-bottom: 0;
        font-size: 15px;
    }

    tr b {
        font-size: 18px;
    }

    table.table th {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    table.table td {
        padding-top: 0.1rem;
        padding-bottom: 0.9rem;
    }

    .jumbotron {
        border-radius: 6px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;
    }

    p {
        margin-bottom: 0;
    }
</style>
